// extracted by mini-css-extract-plugin
module.exports = {"root":"FourTile_root__xt8zj","contentTiles":"FourTile_contentTiles__339HN"};